import { render, staticRenderFns } from "./scienceJq.vue?vue&type=template&id=f526bc7e&scoped=true&"
import script from "./scienceJq.vue?vue&type=script&lang=js&"
export * from "./scienceJq.vue?vue&type=script&lang=js&"
import style0 from "./scienceJq.vue?vue&type=style&index=0&id=f526bc7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f526bc7e",
  null
  
)

component.options.__file = "scienceJq.vue"
export default component.exports